import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function atLeastOneRequiredValidator(group: AbstractControl): ValidationErrors | null {
    const form = group as UntypedFormGroup;
    const annees = form.get('annees').value;
    const cdcs = form.get('cdcs').value;
    const dateMin = form.get('dateMin').value;

    const hasValue = (value: any) => (Array.isArray(value) ? value.length > 0 : !!value);

    if (hasValue(annees) || hasValue(cdcs) || hasValue(dateMin)) {
        return null; // valid
    }

    return { atLeastOneRequired: true };
}
